import script from "./FichaOpinion.vue?vue&type=script&lang=ts&setup=true"
export * from "./FichaOpinion.vue?vue&type=script&lang=ts&setup=true"

import "./FichaOpinion.vue?vue&type=style&index=0&id=7d06de92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d06de92"]])

export default __exports__